<!--
  리뷰 슬라이드(Radial) 컴포넌트
-->
<template>
  <div
    :id="slideId"
  >
    <div class="review_content">

      <h2>수강생 리얼 후기로<br>보증합니다!</h2>

      <!-- 리뷰 리스트 -->
      <div
        :class="['wrap_review_list']"
      >
        <div
          :class="['review_inner']"
          data-direction="next"
        />

        <!-- slide navigation -->
        <div class="slide_nav">
          <button
            class="btn_radial_slide prev"
            @click.prevent="changeFocusedIndex('prev')"
          >prev</button>
          <button
            class="btn_radial_slide next"
            @click.prevent="changeFocusedIndex('next')"
          >next</button>
        </div>
        <!-- // slide navigation -->

      </div>
      <!-- // 리뷰 리스트 -->

    </div>
  </div>
</template>

<script>
import CompReviewRate from './CompReviewRate.vue'
export default {
  name: 'CompReviewRadialSlide',
  components: {
    CompReviewRate
  },
  data () {
    return {
      slideId: 'reviewRadialSlide',
      viewportWidth: 0, // 브라우저 뷰포트 width
      viewportHeight: 0, // 브라우저 뷰포트 height
      isDesktop: true, // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
      isMobile: false, // 현재 디바이스 viewport width 가 모바일 사이즈인 경우 true
      isFanUi: true, // 부채꼴 UI 여부 (PC 인 경우 true)
      item: {
        length: 0, // 데이터 갯수
        angle: 8, // 리뷰 슬라이드 이동시 변경되는 기본 각도
        slideWidth: 0, // 리뷰 슬라이드 넓이
        focusedIndex: 0, // 현재 포커싱 되어 있는 index (기본값 0, rotate 실행시 값 업데이트 됨)
        maxReviewRate: 5, // 리뷰 만점 > 5 (이 값을 기준으로 상대적으로 별점 색상 채워짐)
        data: null // 배너 데이터
      }
    }
  },
  computed: {

  },
  watch: {
    isDesktop (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setFanClass()
        this.initReviewData() // 리뷰 데이터 초기화
      }
    }
  },
  beforeCreate () {

  },
  created () {

  },
  beforeMount () {

  },
  mounted () {
    this.setFanClass() // 부채꼴 UI 클래스 설정
    this.initRadialSlide() // 리뷰 슬라이드 실행
    this.setSwipeEvent() // 모바일 터치 스와이프 이벤트
  },
  beforeUpdate () {

  },
  updated () {

  },
  beforeDestroy () {
    this.removeSwipeEvent()
  },
  methods: {
    // 부채꼴 UI 클래스 설정
    setFanClass () {
      const fanEl = document.querySelector('.wrap_review_list')

      if (this.isDesktop) {
        fanEl.classList.add('fan')
        this.isFanUi = true
      } else {
        fanEl.classList.remove('fan')
        this.isFanUi = false
      }
    },
    // 터치 스와이프 이벤트
    setSwipeEvent () {
      const _this = this
      let pageWidth = window.innerWidth || document.body.clientWidth
      let treshold = Math.max(1, Math.floor(0.01 * (pageWidth)))
      let touchstartX = 0
      let touchstartY = 0
      let touchendX = 0
      let touchendY = 0

      const limit = Math.tan(45 * 1.5 / 180 * Math.PI)
      const gestureZone = document.querySelector('.wrap_review_list .review_inner')

      // 핸들러 함수들
      const handleTouchStart = function (event) {
        touchstartX = event.changedTouches[0].screenX
        touchstartY = event.changedTouches[0].screenY
      }

      const handleTouchEnd = function (event) {
        touchendX = event.changedTouches[0].screenX
        touchendY = event.changedTouches[0].screenY
        handleGesture(event)
      }

      function handleGesture (e) {
        let x = touchendX - touchstartX
        let y = touchendY - touchstartY
        let yx = Math.abs(y / x)
        if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
          if (yx <= limit) {
            if (x < 0) {
              _this.changeFocusedIndex('next')
            } else {
              _this.changeFocusedIndex('prev')
            }
          }
        }
      }
      // 이벤트 리스너 등록
      gestureZone.addEventListener('touchstart', handleTouchStart, false)
      gestureZone.addEventListener('touchend', handleTouchEnd, false)

      // 이벤트 리스너 제거 함수
      this.removeSwipeEvent = function () {
        gestureZone.removeEventListener('touchstart', handleTouchStart, false)
        gestureZone.removeEventListener('touchend', handleTouchEnd, false)
      }
    },
    // 배너 데이터 설정
    getReviewData () {
      let result
      // NOTE: 데이터 처리 (data가 3개 이상 존재해야 rotate 기능이 정상 동작함)

      result = [
        {
          title: '1. ChatGPT와 랭체인(Lang Chain)을 활용한 LLM 이해',
          stUrl: 'javascript:void(0)',
          desc: '강사님이 전문적인 역량을 가지고 있어서 잘 배울 수 있었으나, 지식의 차이로 인해 수업을 다 따라가기에는 개인적으로 아쉬움도 있었습니다.',
          userName: '이*님',
          date: '2024.02.05',
          rate: 3.5
        },
        {
          title: '2. ChatGPT와 랭체인(Lang Chain)을 활용한 LLM 이해',
          stUrl: 'javascript:void(0)',
          desc: '실습 수업, 쉬운 설명, 유용한 자료',
          userName: '이*님',
          date: '2024.02.05',
          rate: 5
        },
        {
          title: '3. ChatGPT와 랭체인(Lang Chain)을 활용한 LLM 이해',
          stUrl: 'javascript:void(0)',
          desc: '강의도 알차고 얻어가는 내용도 많았습니다.<br>실무에서 사용할 수 있을 거라는 부분도 상당히 많았구요. 질문에도 차분하고 자세하게 알려주셔서 고마웠습니다.',
          userName: '이*님',
          date: '2024.02.05',
          rate: 4.5
        },
        {
          title: '4. ChatGPT와 랭체인(Lang Chain)을 활용한 LLM 이해',
          stUrl: 'javascript:void(0)',
          desc: '과정명에 언급된 것처럼 업무에 바로 활용할 수 있을 내용들이어서 도움이 되었습니다.',
          userName: '이*님',
          date: '2024.02.05',
          rate: 2.5
        },
        {
          title: '5. ChatGPT와 랭체인(Lang Chain)을 활용한 LLM 이해',
          stUrl: 'javascript:void(0)',
          desc: '강의도 알차고 얻어가는 내용도 많았습니다.<br>실무에서 사용할 수 있을 거라는 부분도 상당히 많았구요. 질문에도 차분하고 자세하게 알려주셔서 고마웠습니다.',
          userName: '이*님',
          date: '2024.02.05',
          rate: 1
        }
      ]

      this.item.data = result
      this.item.length = result.length
      this.initReviewData()
    },
    // 랜덤 색상 코드
    getRndColor () {
      const arrColor = [
        '#D98880',
        '#C39BD3',
        '#7FB3D5',
        '#76D7C4',
        '#F7DC6F',
        '#E59866',
        '#808B96'
      ]
      const _min = 0
      const _max = arrColor.length > 1 ? (arrColor.length - 1) : 0
      const rndNum = _max === 0 ? 0 : (Math.floor(Math.random() * (_max - _min + 1)) + _min)

      return arrColor[rndNum]
    },
    // 슬라이드 UI 초기화
    initRadialSlide () {
      this.getReviewData()
    },
    getItemTransitionData (idx, isVisibleItem) {
      const arrDataIndex = {
        visiblePc: [
          [-2, 'append'],
          [-1, 'append'],
          [0, 'append'],
          [1, 'append'],
          [2, 'append']
        ],
        visibleMo: [
          [-1, 'append'],
          [0, 'append'],
          [1, 'append']
        ],
        hiddenPc: [
          [3, 'append'],
          [-3, 'prepend']
        ],
        hiddenMo: [
          [2, 'append'],
          [-2, 'prepend']
        ]
      }
      const dataIndex = isVisibleItem ? this.isDesktop ? arrDataIndex.visiblePc : arrDataIndex.visibleMo : this.isDesktop ? arrDataIndex.hiddenPc : arrDataIndex.hiddenMo
      const ret = [
        dataIndex[idx][0],
        dataIndex[idx][1],
        dataIndex.length
      ]

      return ret
    },
    // 리뷰 아이템 엘리먼트 삽입
    appendReviewEl (isVisibleItem) {
      const reviewWrapper = document.querySelector('.wrap_review_list .review_inner')
      const focusedIndex = this.item.focusedIndex
      const dataLength = this.item.length
      const visibleSlideLength = this.isDesktop ? 5 : 3 // 노출할 슬라이드 갯수
      const hiddenSlideLength = 2
      const slideLength = isVisibleItem ? visibleSlideLength : hiddenSlideLength
      const angle = this.item.angle
      const slideGapMo = 12
      let i, idx, pos, transitionData, transitionValue, tmpIndex, targetIndex, itemData, itemTemplate, reviewItem, reviewRate, progressWidth, color

      for (i = 0; i < slideLength; i++) {
        transitionData = this.getItemTransitionData(i, isVisibleItem)
        idx = transitionData[0]
        pos = transitionData[1]
        transitionValue = this.isDesktop ? angle * idx : this.item.slideWidth * idx

        if (!this.isDesktop && idx !== 0) {
          transitionValue = idx < 0 ? transitionValue - slideGapMo : transitionValue + slideGapMo
        }

        tmpIndex = focusedIndex + idx
        targetIndex = tmpIndex < 0 ? dataLength + tmpIndex : tmpIndex >= dataLength ? tmpIndex - dataLength : tmpIndex

        itemData = this.item.data[targetIndex]

        reviewRate = itemData.rate
        progressWidth = (reviewRate * 100 / this.item.maxReviewRate).toFixed(2)
        color = this.getRndColor()

        itemTemplate = `
          <span class="icon_comma" style="background-color:${color}">"</span>
          <a class="review_tit" href="${itemData.stUrl}">${itemData.title}</a>
          <span class="review_desc">${itemData.desc}</span>
          <ul class="user_info">
            <li>${itemData.userName}</li>
            <li>${itemData.date}</li>
          </ul>
          <div class="review_rate">
            <div class="rate_icon">
              <div class="mask">
                <div class="progress" style="width:${progressWidth}%;background-color:${color}"></div>
              </div>
            </div>
            <span class="rate_txt">${reviewRate}</span>
          </div>
        `

        reviewItem = document.createElement('div')
        reviewItem.classList.add('review_item')

        if (transitionValue === 0) reviewItem.classList.add('active')

        reviewItem.style.transform = this.isDesktop ? `rotate(${transitionValue}deg)` : `translateX(${transitionValue}px)`
        reviewItem.innerHTML = itemTemplate

        if (pos === 'append') {
          reviewWrapper.appendChild(reviewItem)
        } else {
          reviewWrapper.prepend(reviewItem)
        }
      }
    },
    // 화면에 노출되는 초기 리뷰 데이터 초기화
    initReviewData () {
      const reviewWrapper = document.querySelector('.wrap_review_list .review_inner')

      reviewWrapper.innerHTML = ''
      this.item.slideWidth = window.innerWidth - 54
      this.appendReviewEl(true) // 화면에 노출되는 데이터 설정
      this.setHiddenReviewData() // 화면에 노출되지 않는 데이터 설정
    },
    // 화면에 노출되지 않는(좌우에 숨겨진) 리뷰 데이터 설정
    setHiddenReviewData (dir) {
      const reviews = document.querySelectorAll('.wrap_review_list .review_item')
      const reviewsMaxLength = this.isDesktop ? 5 : 3

      if (reviews.length > reviewsMaxLength) {
        let arrRemoveIndex = [0, reviewsMaxLength + 1]
        if (dir !== undefined) {
          if (dir === 'prev') {
            arrRemoveIndex = [reviewsMaxLength, reviewsMaxLength + 1]
          } else {
            arrRemoveIndex = [0, 1]
          }
        }

        for (let i = 0; i < arrRemoveIndex.length; i++) {
          if (reviews[arrRemoveIndex[i]]) reviews[arrRemoveIndex[i]].remove()
        }
      }

      this.appendReviewEl(false)
    },
    // // prev, next 버튼 존재 여부 리턴
    buttonExists: function () {
      const btnWrapper = document.querySelector('.wrap_review_list .slide_nav')
      const btns = document.querySelectorAll('.wrap_review_list .slide_nav .btn_radial_slide')
      let ret = false

      if (btnWrapper && btns.length > 0) ret = true
      return ret
    },
    // prev, next 버튼 비활성
    buttonDisabled: function () {
      if (this.buttonExists()) {
        const btns = document.querySelectorAll('.wrap_review_list .slide_nav .btn_radial_slide')
        let i, btn

        for (i = 0; i < btns.length; i++) {
          btn = btns[i]
          btn.disabled = true
        }
      }
    },
    // prev, next 버튼 활성
    buttonEnabled: function () {
      if (this.buttonExists()) {
        const btns = document.querySelectorAll('.wrap_review_list .slide_nav .btn_radial_slide')
        let i, btn

        for (i = 0; i < btns.length; i++) {
          btn = btns[i]
          btn.disabled = false
        }
      }
    },
    // 리뷰 아이템 rotate 값 리턴 (PC)
    getRotationValue (reviewEl, dir) {
      const angle = this.item.angle
      const st = window.getComputedStyle(reviewEl, null)
      const trv = st.getPropertyValue('-webkit-transform') || st.getPropertyValue('-moz-transform') || st.getPropertyValue('-ms-transform') || st.getPropertyValue('-o-transform') || st.getPropertyValue('transform') || undefined

      let values = trv.split('(')[1]
      values = values.split(')')[0]
      values = values.split(',')

      const a = values[0]
      const b = values[1]
      const scale = Math.sqrt(a * a + b * b)
      const sin = b / scale
      const currentValue = Math.round(Math.asin(sin) * (180 / Math.PI))
      const newValue = dir === 'prev' ? currentValue + angle : currentValue - angle

      if (newValue === 0) {
        reviewEl.classList.add('active')
      } else {
        reviewEl.classList.remove('active')
      }

      reviewEl.style.transform = `rotate(${newValue}deg)`
    },
    // 리뷰 아이템 translateX 값 리턴 (MO)
    getTranslateValue (reviewEl, dir) {
      const slideWidth = this.item.slideWidth
      const slideGap = 12
      const st = window.getComputedStyle(reviewEl)
      const matrix = new DOMMatrixReadOnly(st.transform)
      const currentValue = matrix.m41
      let newValue

      if (Math.abs(currentValue) > slideWidth + slideGap) {
        newValue = (dir === 'prev') ? currentValue + slideWidth : currentValue - slideWidth
      } else {
        newValue = (dir === 'prev') ? currentValue + slideWidth + slideGap : currentValue - slideWidth - slideGap
      }

      if (newValue === 0) {
        reviewEl.classList.add('active')
      } else {
        reviewEl.classList.remove('active')
      }

      reviewEl.style.transform = `translateX(${newValue}px)`
    },
    // 중앙에 위치할 리뷰 아이템 교체
    changeFocusedIndex (dir) {
      const _this = this
      const focusedIndex = this.item.focusedIndex
      const realIndex = focusedIndex + 1
      const dataLength = this.item.length
      const reviewWrapper = document.querySelector('.wrap_review_list .review_inner')
      const reviews = document.querySelectorAll('.wrap_review_list .review_item')
      let targetIndex, i, reviewEl

      this.buttonDisabled()

      reviewWrapper.setAttribute('data-direction', dir)

      if (dir === 'prev') {
        targetIndex = focusedIndex === 0 ? dataLength - 1 : focusedIndex - 1
      } else {
        targetIndex = realIndex === dataLength ? 0 : focusedIndex + 1
      }

      this.item.focusedIndex = targetIndex

      for (i = 0; i < reviews.length; i++) {
        reviewEl = reviews[i]
        this.isDesktop ? this.getRotationValue(reviewEl, dir) : this.getTranslateValue(reviewEl, dir)
      }

      // transition이 완료되는 시점에 숨은 영역 아이템 채우고 버튼 활성 처리
      setTimeout(function () {
        _this.setHiddenReviewData(dir)
        _this.buttonEnabled()
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompReviewRadialSlide.vue